
import { useNavigate } from 'react-router-dom';

export default function CitizenRegistration() {
  const navigate = useNavigate();

  const handleRegisterClick = () => {
    navigate('/citizen-submission');
  };

  const handleLearnMoreClick = () => {
    // Scroll to the about section or show more info
    const aboutSection = document.querySelector('#about');
    if (aboutSection) {
      aboutSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-red-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Become a <span className="text-red-700">Citizen Reporter</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Join our community of storytellers and help document the rich culture and stories of Northeast India.
          </p>
        </div>

        {/* Steps */}
        <div className="grid md:grid-cols-4 gap-8 mb-16">
          <div className="text-center">
            <div className="w-20 h-20 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
              1
            </div>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-user-add-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Register</h3>
            <p className="text-gray-600">Sign up on our website with your basic details</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
              2
            </div>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-shield-check-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Verify</h3>
            <p className="text-gray-600">Complete identity verification to ensure authentic reporting</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
              3
            </div>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-camera-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Share Stories</h3>
            <p className="text-gray-600">Start sharing stories through text, photos, or videos</p>
          </div>

          <div className="text-center">
            <div className="w-20 h-20 bg-red-700 rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold">
              4
            </div>
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="ri-award-line text-2xl text-red-700"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Get Featured</h3>
            <p className="text-gray-600">Earn recognition and get your stories featured</p>
          </div>
        </div>

        {/* Progress Line */}
        <div className="hidden md:block relative mb-16">
          <div className="absolute top-1/2 left-0 right-0 h-1 bg-red-200 transform -translate-y-1/2"></div>
          <div className="absolute top-1/2 left-0 w-3/4 h-1 bg-red-700 transform -translate-y-1/2"></div>
        </div>

        {/* CTA Buttons */}
        <div className="text-center">
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <button 
              onClick={handleRegisterClick}
              className="bg-red-700 text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-red-800 transition-colors duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Register Now
            </button>
            <button 
              onClick={handleLearnMoreClick}
              className="border-2 border-red-700 text-red-700 px-8 py-4 rounded-xl font-semibold text-lg hover:bg-red-700 hover:text-white transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
            >
              Learn More
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
